module.exports = __webpack_public_path__ + "img/14.dfab79b3.png";